
<script>
export default {

    props: {
        allConversationsIds: {
            required: true
        }
    },

    data() {
        return {
            selectedConversationsIds: [],
            selectedAll: false
        }
    },

    methods: {
        selectAllOrNone() {
            if (this.selectedAll) {
                this.selectedConversationsIds = [];
                this.selectedAll = false;
            } else {
                this.selectedConversationsIds = this.allConversationsIds;
                this.selectedAll = true;
            }
        },

        selectInverted() {
            let inverted = this.allConversationsIds
                .filter(
                    id => this.selectedConversationsIds.indexOf(id) === -1
                );

            this.selectedConversationsIds = inverted;
            this.selectedAll = this.allConversationsIds.length === this.selectedConversationsIds.length;
        },

        markArchived() {
            if (! this.selectedConversationsIds.length){
                return;
            }

            axios
                .patch(url('/conversations/mark-archived'), {
                    selectedConversationsIds: this.selectedConversationsIds
                })
                .then(response => {
                    window.location.reload();
                })
                .catch(errors => {
                    console.log(errors);
                });
        },

        markRead() {
            if (! this.selectedConversationsIds.length){
                return;
            }

            axios
                .patch(url('/conversations/mark-read'), {
                    selectedConversationsIds: this.selectedConversationsIds
                })
                .then(response => {
                    window.location.reload();
                })
                .catch(errors => {
                    console.log(errors);
                });
        }
    }
}
</script>
